import { Card, StatCard } from '@/components'
import { cariAngka } from '@/components/LaporanTampil'
import { formatRupiah } from '@/lib/format'
import { HalamanLaporan } from './HalamanLaporan'

/**
 * Arus Kas: klasifikasi operasi / investasi / pendanaan, ditambah rekonsiliasi
 * saldo awal menjadi saldo akhir.
 */
export default function ArusKas() {
  return (
    <HalamanLaporan
      judul="Arus Kas"
      deskripsi="Arus kas dari aktivitas operasi, investasi, dan pendanaan, serta rekonsiliasi saldo kas."
      path="/reports/cash-flow"
      namaEkspor="arus-kas"
      ekstraKonten={(data) => {
        const operasi = cariAngka(data, ['arusKasOperasi', 'operasi', 'kasDariOperasi', 'operating'])
        const investasi = cariAngka(data, ['arusKasInvestasi', 'investasi', 'kasDariInvestasi', 'investing'])
        const pendanaan = cariAngka(data, ['arusKasPendanaan', 'pendanaan', 'kasDariPendanaan', 'financing'])
        const awal = cariAngka(data, ['saldoAwal', 'saldoKasAwal', 'openingBalance', 'kasAwal'])
        const akhir = cariAngka(data, ['saldoAkhir', 'saldoKasAkhir', 'closingBalance', 'kasAkhir'])

        const adaKlasifikasi = operasi !== null || investasi !== null || pendanaan !== null
        const adaRekonsiliasi = awal !== null || akhir !== null
        if (!adaKlasifikasi && !adaRekonsiliasi) return null

        const totalPerubahan = (operasi ?? 0) + (investasi ?? 0) + (pendanaan ?? 0)

        return (
          <div className="mb-5 space-y-4">
            {adaKlasifikasi ? (
              <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
                <StatCard
                  label="Arus Kas Operasi"
                  nilai={operasi}
                  nada={(operasi ?? 0) >= 0 ? 'hijau' : 'merah'}
                  formatNilai={(v) => formatRupiah(Number(v ?? 0))}
                />
                <StatCard
                  label="Arus Kas Investasi"
                  nilai={investasi}
                  formatNilai={(v) => formatRupiah(Number(v ?? 0))}
                />
                <StatCard
                  label="Arus Kas Pendanaan"
                  nilai={pendanaan}
                  formatNilai={(v) => formatRupiah(Number(v ?? 0))}
                />
              </div>
            ) : null}

            {adaRekonsiliasi ? (
              <Card>
                <h3 className="text-sm font-semibold text-netral-800">Rekonsiliasi Saldo Kas</h3>
                <div className="mt-3 flex flex-wrap items-center gap-3 text-sm">
                  <span className="text-netral-600">
                    Saldo awal <strong className="angka-tabular">{formatRupiah(awal ?? 0)}</strong>
                  </span>
                  <span className="text-netral-400">+</span>
                  <span className="text-netral-600">
                    Perubahan kas <strong className="angka-tabular">{formatRupiah(totalPerubahan)}</strong>
                  </span>
                  <span className="text-netral-400">=</span>
                  <span className="font-semibold text-netral-900">
                    Saldo akhir {formatRupiah(awal !== null ? (awal ?? 0) + totalPerubahan : (akhir ?? 0))}
                  </span>
                  {akhir !== null && awal !== null && Math.abs((awal + totalPerubahan) - akhir) > 0.005 ? (
                    <span className="text-xs font-medium text-red-700">
                      (selisih dengan saldo akhir API: {formatRupiah(akhir - (awal + totalPerubahan))})
                    </span>
                  ) : null}
                </div>
              </Card>
            ) : null}
          </div>
        )
      }}
    />
  )
}
